import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faInfoCircle, faCrown, faExchangeAlt, faTimesCircle, faArrowRight, faCheckCircle, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import '../../styles/logistic/LogisticPricingSection.css';
import { useTranslation } from 'react-i18next';

const LogisticPricingSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="logistic-pricing-section">
      <div className="logistic-container">
        <div className="logistic-section-header">
          <span className="logistic-section-tag">{t('LogisticPricingSection:section_tag')}</span>
          <h2>
            {t('LogisticPricingSection:title_prefix')}{' '}
            <span className="logistic-text-primary">{t('LogisticPricingSection:title_strong')}</span>
          </h2>
          <p>{t('LogisticPricingSection:subtitle')}</p>
        </div>

        <div className="logistic-pricing-grid">
          <div className="logistic-pricing-card">
            <div className="logistic-pricing-header">
              <h3>{t('LogisticPricingSection:plan1_title')}</h3>
              <p>{t('LogisticPricingSection:plan1_description')}</p>
            </div>
            <div className="logistic-pricing-price">
              <span className="logistic-currency">$</span>
              <span className="logistic-amount">{t('LogisticPricingSection:plan1_price')}</span>
              <span className="logistic-period">{t('LogisticPricingSection:plan1_period')}</span>
            </div>
            <div className="logistic-pricing-features">
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>
                  <strong>{t('LogisticPricingSection:plan1_feature1_strong')}</strong>
                  {t('LogisticPricingSection:plan1_feature1_suffix')}
                </span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{t('LogisticPricingSection:plan1_feature2')}</span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{t('LogisticPricingSection:plan1_feature3')}</span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{t('LogisticPricingSection:plan1_feature4')}</span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{t('LogisticPricingSection:plan1_feature5')}</span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faInfoCircle} />
                <span>
                  <em>{t('LogisticPricingSection:plan1_feature6')}</em>
                </span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faInfoCircle} />
                <span>
                  <em>{t('LogisticPricingSection:plan1_feature7')}</em>
                </span>
              </div>
            </div>
            <a href="#cta" className="logistic-btn-pricing">{t('LogisticPricingSection:start_now_button')}</a>
            <div className="logistic-pricing-note">
              <FontAwesomeIcon icon={faInfoCircle} />
              <span>
                {t('LogisticPricingSection:plan1_note_prefix')}{' '}
                <strong>{t('LogisticPricingSection:plan1_note_strong')}</strong>
              </span>
            </div>
          </div>

          <div className="logistic-pricing-card logistic-featured">
            <div className="logistic-pricing-badge">
              <FontAwesomeIcon icon={faCrown} /> {t('LogisticPricingSection:plan2_badge')}
            </div>
            <div className="logistic-pricing-header">
              <h3>{t('LogisticPricingSection:plan2_title')}</h3>
              <p>{t('LogisticPricingSection:plan2_description')}</p>
            </div>
            <div className="logistic-pricing-price">
              <span className="logistic-currency">$</span>
              <span className="logistic-amount">{t('LogisticPricingSection:plan2_price')}</span>
              <span className="logistic-period">{t('LogisticPricingSection:plan2_period')}</span>
            </div>
            <div className="logistic-pricing-features">
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>
                  <strong>{t('LogisticPricingSection:plan2_feature1_strong')}</strong>
                  {t('LogisticPricingSection:plan2_feature1_suffix')}
                </span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>
                  <strong>{t('LogisticPricingSection:plan2_feature2_strong')}</strong>
                </span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{t('LogisticPricingSection:plan2_feature3')}</span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{t('LogisticPricingSection:plan2_feature4')}</span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{t('LogisticPricingSection:plan2_feature5')}</span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{t('LogisticPricingSection:plan2_feature6')}</span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faInfoCircle} />
                <span>
                  <em>{t('LogisticPricingSection:plan2_feature7')}</em>
                </span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faInfoCircle} />
                <span>
                  <em>{t('LogisticPricingSection:plan2_feature8')}</em>
                </span>
              </div>
            </div>
            <a href="#cta" className="logistic-btn-pricing logistic-pulse">{t('LogisticPricingSection:start_now_button')}</a>
            <div className="logistic-pricing-note">
              <FontAwesomeIcon icon={faInfoCircle} />
              <span>
                {t('LogisticPricingSection:plan2_note_prefix')}{' '}
                <strong>{t('LogisticPricingSection:plan2_note_strong')}</strong>
              </span>
            </div>
          </div>

          <div className="logistic-pricing-card">
            <div className="logistic-pricing-header">
              <h3>{t('LogisticPricingSection:plan3_title')}</h3>
              <p>{t('LogisticPricingSection:plan3_description')}</p>
            </div>
            <div className="logistic-pricing-price">
              <span className="logistic-currency">$</span>
              <span className="logistic-amount">{t('LogisticPricingSection:plan3_price')}</span>
              <span className="logistic-period">{t('LogisticPricingSection:plan3_period')}</span>
            </div>
            <div className="logistic-pricing-features">
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>
                  <strong>{t('LogisticPricingSection:plan3_feature1_strong')}</strong>
                  {t('LogisticPricingSection:plan3_feature1_suffix')}
                </span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>
                  <strong>{t('LogisticPricingSection:plan3_feature2_strong')}</strong>
                </span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{t('LogisticPricingSection:plan3_feature3')}</span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{t('LogisticPricingSection:plan3_feature4')}</span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{t('LogisticPricingSection:plan3_feature5')}</span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>
                  <strong>{t('LogisticPricingSection:plan3_feature6_strong')}</strong>
                </span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>
                  <strong>{t('LogisticPricingSection:plan3_feature7_strong')}</strong>
                </span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{t('LogisticPricingSection:plan3_feature8')}</span>
              </div>
            </div>
            <a href="#cta" className="logistic-btn-pricing">{t('LogisticPricingSection:start_now_button')}</a>
            <div className="logistic-pricing-note">
              <FontAwesomeIcon icon={faInfoCircle} />
              <span>
                {t('LogisticPricingSection:plan3_note_prefix')}{' '}
                <strong>{t('LogisticPricingSection:plan3_note_strong')}</strong>
              </span>
            </div>
          </div>

          <div className="logistic-pricing-card">
            <div className="logistic-pricing-header">
              <h3>{t('LogisticPricingSection:plan4_title')}</h3>
              <p>{t('LogisticPricingSection:plan4_description')}</p>
            </div>
            <div className="logistic-pricing-price">
              <span className="logistic-currency">$</span>
              <span className="logistic-amount">{t('LogisticPricingSection:plan4_price')}</span>
              <span className="logistic-period">{t('LogisticPricingSection:plan4_period')}</span>
            </div>
            <div className="logistic-pricing-features">
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>
                  <strong>{t('LogisticPricingSection:plan4_feature1_strong')}</strong>
                  {t('LogisticPricingSection:plan4_feature1_suffix')}
                </span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>
                  <strong>{t('LogisticPricingSection:plan4_feature2_strong')}</strong>
                </span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{t('LogisticPricingSection:plan4_feature3')}</span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{t('LogisticPricingSection:plan4_feature4')}</span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{t('LogisticPricingSection:plan4_feature5')}</span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>
                  <strong>{t('LogisticPricingSection:plan4_feature6_strong')}</strong>
                </span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>
                  <strong>{t('LogisticPricingSection:plan4_feature7_strong')}</strong>
                </span>
              </div>
              <div className="logistic-feature-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>
                  <strong>{t('LogisticPricingSection:plan4_feature8_strong')}</strong>
                </span>
              </div>
            </div>
            <a href="#cta" className="logistic-btn-pricing">{t('LogisticPricingSection:start_now_button')}</a>
            <div className="logistic-pricing-note">
              <FontAwesomeIcon icon={faInfoCircle} />
              <span>
                {t('LogisticPricingSection:plan4_note_prefix')}{' '}
                <strong>{t('LogisticPricingSection:plan4_note_strong')}</strong>
              </span>
            </div>
          </div>
        </div>

        <div className="logistic-pricing-comparison">
          <h3>{t('LogisticPricingSection:comparison_title')}</h3>
          <div className="logistic-comparison-calc">
            <div className="logistic-calc-item logistic-old">
              <h4>{t('LogisticPricingSection:traditional_title')}</h4>
              <div className="logistic-calc-detail">
                <span>{t('LogisticPricingSection:traditional_detail_text')}</span>
                <strong>{t('LogisticPricingSection:traditional_detail_strong')}</strong>
              </div>
              <ul>
                <li>{t('LogisticPricingSection:traditional_item1')}</li>
                <li>{t('LogisticPricingSection:traditional_item2')}</li>
                <li>{t('LogisticPricingSection:traditional_item3')}</li>
                <li>{t('LogisticPricingSection:traditional_item4')}</li>
                <li>{t('LogisticPricingSection:traditional_item5')}</li>
                <li>{t('LogisticPricingSection:traditional_item6')}</li>
              </ul>
              <div className="logistic-total-cost">
                <strong>{t('LogisticPricingSection:traditional_total_strong')}</strong>
                <div style={{ fontSize: '14.4px', marginTop: '8px' }}>
                  {t('LogisticPricingSection:traditional_total_text')}
                </div>
              </div>
            </div>

            <div className="logistic-calc-divider">
              <FontAwesomeIcon icon={faExchangeAlt} />
              <span>VS</span>
            </div>

            <div className="logistic-calc-item logistic-new">
              <div className="logistic-comparison-header">
                <FontAwesomeIcon icon={faCheckCircle} />
                <h4>{t('LogisticPricingSection:ai_title')}</h4>
              </div>
              <ul>
                <li>{t('LogisticPricingSection:ai_item1')}</li>
                <li>{t('LogisticPricingSection:ai_item2')}</li>
                <li>{t('LogisticPricingSection:ai_item3')}</li>
                <li>{t('LogisticPricingSection:ai_item4')}</li>
                <li>{t('LogisticPricingSection:ai_item5')}</li>
                <li>{t('LogisticPricingSection:ai_item6')}</li>
              </ul>
              <div className="logistic-total-cost logistic-success">
                <strong>{t('LogisticPricingSection:ai_total_strong')}</strong>
                <span className="logistic-savings">{t('LogisticPricingSection:ai_savings')}</span>
                <div style={{ fontSize: '14.4px', marginTop: '8px' }}>
                  <strong>{t('LogisticPricingSection:ai_equivalent_strong')}</strong>
                </div>
              </div>
            </div>
          </div>
          
          <div className='logistic-comparison-analysis'>
            <h4 className='logistic-comparison-analysis-title'>{t('LogisticPricingSection:analysis_title')}</h4>
            <p className='logistic-comparison-analysis-text'>
              {t('LogisticPricingSection:analysis_text_1')}
              <strong>{t('LogisticPricingSection:analysis_text_1_strong')}</strong>
              {t('LogisticPricingSection:analysis_text_1_suffix')}
              <strong>{t('LogisticPricingSection:analysis_text_2_strong')}</strong>
              {t('LogisticPricingSection:analysis_text_2_suffix')}
              <strong>{t('LogisticPricingSection:analysis_text_3_strong')}</strong>
              <br/>
              {t('LogisticPricingSection:analysis_text_4')}
              <strong>{t('LogisticPricingSection:analysis_text_4_strong')}</strong>
              {t('LogisticPricingSection:analysis_text_4_suffix')}
              <br/>
              <strong className='logistic-comparison-analysis-important'>
                {t('LogisticPricingSection:analysis_text_5_strong')}
              </strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogisticPricingSection;